(() => {
  const runtimeName = 'SafeWalkV51Product';
  const queuedFeatures = window.SafeWalkV51ProductQueue || [];
  if (window[runtimeName]?.register) {
    queuedFeatures.splice(0).forEach(([name, initializer]) => window[runtimeName].register(name, initializer));
    window[runtimeName].initWithin(document);
    return;
  }

  const features = new Map();
  const rootStates = new WeakMap();
  const rootsWithin = (scope) => {
    const roots = [];
    if (scope instanceof Element && scope.matches('[data-swv5-section]')) roots.push(scope);
    if (scope?.querySelectorAll) roots.push(...scope.querySelectorAll('[data-swv5-section]'));
    return Array.from(new Set(roots));
  };
  const parseJson = (root, selector, fallback = {}) => {
    const node = root.querySelector(selector);
    if (!node) return fallback;
    try {
      const parsed = JSON.parse(node.textContent || '');
      return parsed && typeof parsed === 'object' ? parsed : fallback;
    } catch (error) {
      return fallback;
    }
  };
  const initializeFeature = (root, name, initializer) => {
    let state = rootStates.get(root);
    if (!state) {
      state = new Map();
      rootStates.set(root, state);
    }
    if (state.has(name)) return true;
    const cleanups = [];
    const context = {
      root,
      parseJson: (selector, fallback) => parseJson(root, selector, fallback),
      addCleanup: (cleanup) => {
        if (typeof cleanup === 'function') cleanups.push(cleanup);
      },
      listen: (target, type, handler, options) => {
        if (!target?.addEventListener) return;
        target.addEventListener(type, handler, options);
        cleanups.push(() => target.removeEventListener(type, handler, options));
      }
    };
    let result;
    try {
      result = initializer(context);
    } catch (error) {
      cleanups.reverse().forEach((cleanup) => cleanup());
      root.dataset.swv5RuntimeError = name;
      return false;
    }
    if (result === false) {
      cleanups.reverse().forEach((cleanup) => cleanup());
      return false;
    }
    if (typeof result === 'function') cleanups.push(result);
    state.set(name, () => cleanups.splice(0).reverse().forEach((cleanup) => cleanup()));
    root.dataset.swv5RuntimeInitialized = 'true';
    return true;
  };
  const initRoot = (root) => {
    if (!(root instanceof HTMLElement)) return;
    for (let pass = 0; pass < 2; pass += 1) {
      features.forEach((initializer, name) => initializeFeature(root, name, initializer));
    }
  };
  const initWithin = (scope = document) => rootsWithin(scope).forEach(initRoot);
  const destroyRoot = (root) => {
    const state = rootStates.get(root);
    if (state) Array.from(state.values()).reverse().forEach((destroy) => destroy());
    rootStates.delete(root);
    root.removeAttribute('data-swv5-runtime-initialized');
    root.removeAttribute('data-swv5-runtime-error');
  };
  const destroyWithin = (scope = document) => rootsWithin(scope).forEach(destroyRoot);
  const refreshAllRoots = () => {
    rootsWithin(document).forEach((root) => {
      destroyRoot(root);
      initRoot(root);
    });
  };
  const register = (name, initializer) => {
    if (!name || typeof initializer !== 'function' || features.has(name)) return;
    features.set(name, initializer);
    if (document.readyState !== 'loading') initWithin(document);
  };
  window[runtimeName] = { register, initWithin, destroyWithin };
  window.SafeWalkV51ProductQueue = queuedFeatures;
  queuedFeatures.splice(0).forEach(([name, initializer]) => register(name, initializer));

  const boot = () => initWithin(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target?.querySelector?.('[data-swv51-calculator-shell]')) {
      queueMicrotask(refreshAllRoots);
      return;
    }
    initWithin(event.target);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    const calculatorSection = event.target?.querySelector?.('[data-swv51-calculator-shell]');
    destroyWithin(event.target);
    if (calculatorSection) queueMicrotask(refreshAllRoots);
  });
	  document.addEventListener('shopify:block:select', (event) => {
	    const target = event.target;
	    if (!(target instanceof Element) || !target.closest('[data-swv5-section]')) return;
	    const details = target.closest('details[data-swv51-editor-open]') || target.querySelector('details[data-swv51-editor-open]');
	    if (details) details.open = true;
	  });
})();
